import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { USER_ROLES_ENUM, zUserInfo, zUsername } from "@dobrh-monorepo/core";

export const requestSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  username: zUsername(),
  companyName: z.string(),
  email: z.string().email().toLowerCase(),
  password: z.string().min(8),
  gender: z.number(),
  country: z.string(),
  role: z.nativeEnum(USER_ROLES_ENUM),
});

const responseSchema = z.union([
  z.object({
    message: z.string(),
    accessToken: z.string(),
    userProfile: zUserInfo,
  }),
  z.object({
    userId: z.string(),
    email: z.string(),
    emailRes: z.boolean(),
  }),
]);

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
